export default __webpack_public_path__ + "img/comprobante.fd81febc.jpg";